import { createConfirmation } from "react-confirm";
import AddSubCategoryDialog from "./AddSubCategoryDialog";

export const showAddSubCategoryDialog = createConfirmation(AddSubCategoryDialog);
